import axios from "axios";
import { API_URL } from "./ServiceAPI";

export const TableDataAPI = {
  getRows: (targetUserId) => {
    const params = targetUserId ? { targetUserId } : {};
    return axios.get(`${API_URL}/TableData/rows`, { params });
  },

  getTargetUsers: () => {
    return axios.get(`${API_URL}/TableData/users`);
  },

  getImportStatus: () => {
    return axios.get(`${API_URL}/TableData/import-status`);
  },

  importRows: (data) => {
    return axios.post(`${API_URL}/TableData/imports`, data);
  },
};
